(function () {
  if (window.DS_qv) return;
  var cache = {}, modal, body, lastFocus;
  function t(k, fb) { return (window.DS_T && window.DS_T[k]) || fb; }
  function build() {
    modal = document.createElement('div');
    modal.className = 'ds ds-qv';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', t('quick_view', 'Quick view'));
    modal.innerHTML = '<div class="ds-qv__backdrop" data-qv-close></div><div class="ds-qv__panel"><button type="button" class="ds-qv__x" data-qv-close aria-label="' + t('close', 'Close') + '">×</button><div class="ds-qv__body"></div></div>';
    document.body.appendChild(modal);
    body = modal.querySelector('.ds-qv__body');
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-qv-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  }
  function load(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('load'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-ds-pdp]');
          if (!el) throw new Error('nopdp');
          return (el.closest('.shopify-section') || el).innerHTML;
        });
      cache[url].catch(function () { delete cache[url]; });
    }
    return cache[url];
  }
  function open(url) {
    if (!modal) build();
    lastFocus = document.activeElement;
    body.innerHTML = '<div class="ds-qv__loading"><span></span></div>';
    modal.classList.add('is-open');
    document.documentElement.classList.add('ds-qv-lock');
    load(url).then(function (html) {
      body.innerHTML = html + '<div class="ds-qv__full"><a class="ds-btn ds-btn--ghost ds-btn--block" href="' + url + '">' + t('view_full', 'View full details') + ' <span aria-hidden="true">→</span></a></div>';
      body.querySelectorAll('.ds-reveal').forEach(function (e) { e.classList.add('is-in'); });
      if (window.DS_pdp_init) window.DS_pdp_init(body);
      var x = modal.querySelector('.ds-qv__x'); if (x) x.focus({ preventScroll: true });
    }).catch(function () { window.location.href = url; });
  }
  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('ds-qv-lock');
    setTimeout(function () { if (!modal.classList.contains('is-open')) body.innerHTML = ''; }, 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  var SEL = '[data-ds-qv] .ds-card__media, [data-ds-qv] .ds-card__title';
  document.addEventListener('click', function (e) {
    var a = e.target.closest(SEL);
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    open(a.getAttribute('href'));
  });
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest(SEL);
    if (a) load(a.getAttribute('href')).catch(function () {});
  }, { passive: true });
  window.DS_qv = { open: open, close: close };
})();